import { inject, Injectable } from '@angular/core';
import { Auth, GoogleAuthProvider } from '@angular/fire/auth';
import { signInWithPopup, User } from 'firebase/auth';

@Injectable({
    providedIn: 'root'
})
export class AuthGoogleService {
    private readonly fireAuth = inject(Auth);

    public async auth(): Promise<User | null> {
        try {
            const provider = new GoogleAuthProvider();
            const result = await signInWithPopup(this.fireAuth, provider);

            return result.user;
        } catch (error) {
            console.error('Google Sign-In Error:', error);

            return null;
        }
    }
}
